import { helpers, required } from "@vuelidate/validators";

// Shared validation rules for network fields
export const baseNetworkRules = {
    networkName: {
        required: helpers.withMessage("Network Name is required", required)
    },
    networkId: {
        required: helpers.withMessage("Network ID is required", required)
    },
    marketType: {
        required: helpers.withMessage("Market Type is required", required)
    },
    status: {
        required: helpers.withMessage("Network Status is required", required)
    }
};

